import { useRouter } from 'next/router';
import { useCallback } from 'react';

export const usePreserveHashRouter = () => {
  const router = useRouter();

  const pushWithHash = useCallback(
    (url: string) => {
      const hash = window.location.hash;
      const query = window.location.search;
      void router.push(url + query + hash);
    },
    [router]
  );

  return { ...router, push: pushWithHash };
};
